module.exports = __webpack_public_path__ + "img/banner2.147fac77.jpg";